import { api } from '@src/constants/api';
import { createMiddleware, Next } from '@src/utils';
import { chatbotActions } from '@src/store/reducers/chatbotReducer';

export const createChatbotMiddleware =  (http: any, successPopUp: any, errorPopUp: any) => {
    const restServiceUrl: string = api.restServiceUrl;
    return createMiddleware({
        [chatbotActions.GET_CHATBOT_TYPES]: async (_: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Genie/Types`);
            const data = response.data;
            next({ type: chatbotActions.SET_CHATBOT_TYPES, payload: data });
            return data;
        },
        [chatbotActions.GET_CHATBOTS]:  async (_: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Genie/Configurations`);
            const data = response.data;
            next({ type: chatbotActions.SET_CHATBOTS, payload: data });
            return data;
        },
        [chatbotActions.GET_CHATBOT_BY_ID]: async ({ payload }: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Genie/Configuration/${payload.chatbotId}`);
            next({ type: chatbotActions.SET_CHATBOT_BY_ID, payload: response.data });
            return response.data;
        },
        [chatbotActions.SET_CHATBOT_CONFIGURATION]:  async ({ payload }: any) => {
            try {
                const url = `${restServiceUrl}Genie/AddConfiguration`;
                const response = await http.post(url, payload.chatbot_configuration);
                const data = response.data;
                if (data) {
                    successPopUp();
                } else {
                    errorPopUp();
                }
                return data;
            } catch {
                errorPopUp();
            }
        },
        [chatbotActions.TEST_CHATBOT_CONNECTION]:  async ({ payload }: any, next: Next) => {
            try {
                const response = await http.post(`${restServiceUrl}Genie/TestConfiguration`, payload.testData);
                const data = response.data;
                if (data) {
                    const messageObj = { message: 'Success Action - Test Chatbot Connection', text: '' };
                    successPopUp(messageObj);
                } else {
                    errorPopUp();
                }
                next({ type: chatbotActions.REUSLT_TEST_CHATBOT_CONNECTION, payload: data });
            } catch {
                errorPopUp();
            }
        },
        [chatbotActions.UPDATE_CHATBOT_CONFIGURATION]:  async ({ payload }: any) => {
            try {
                const response = await http.post(`${restServiceUrl}Genie/UpdateConfiguration`, payload.update_chatbot);
                const data = response.data;
                if (data) {
                    successPopUp();
                } else {
                    errorPopUp();
                }
                return data;
            } catch {
                errorPopUp();
            }
        },
        [chatbotActions.DELETE_CHATBOT_CONFIGURATION]: async ({ payload }: any, next: Next) => {
            try {
                const response = await http.delete(`${restServiceUrl}Genie/DeleteConfiguration/${payload.chatbotId}`);
                const data = response.data;
                if (data) {
                    successPopUp();
                    next({ type: chatbotActions.REFRESH_DELETE_CHATBOT, payload: payload.chatbotId });
                } else {
                    errorPopUp();
                }
                return response;
            } catch {
                errorPopUp();
            }
        },
        [chatbotActions.GET_CHATBOTS_WITH_CREDENTIALS]: async (_: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Chatbot/ChatbotsWithCredentials`);
            const data = response.data;
            next({ type: chatbotActions.SET_CHATBOTS_WITH_CREDENTIALS, payload: data });
            return data;
        },
        [chatbotActions.GET_CHATBOT_CONFIGURATION]: async ({ payload }: any) => {
            const response = await http.get(`${restServiceUrl}Chatbot/Template/Configuration/${payload.chatbotTypeId}`);
            return response.data;
        },
        [chatbotActions.GET_CHATBOT_CREDENTIALS]: async ({ payload }: any) => {
            const response = await http.get(`${restServiceUrl}Chatbot/Template/Credentials/${payload.chatbotId}`);
            return response.data;
        },
        [chatbotActions.GET_CHATBOT_CONNECTION]: async ({ payload }: any) => {
            const response = await http.get(`${restServiceUrl}Chatbot/Template/Connection/${payload.chatbotId}`);
            return response.data;
        },
        [chatbotActions.POST_CHATBOT_CREDENTIALS]: async ({ payload }: any) => {
            const response = await http.post(`${restServiceUrl}Chatbot/Template/Credentials/${ payload.chatbot.ChatbotTypeId}`, payload.chatbot);
            return response.data;
        },
        [chatbotActions.POST_CHATBOT_CONNECTION]: async ({ payload }: any) => {
            const response = await http.post(`${restServiceUrl}Chatbot/Template/Connection/${payload.chatbot.ChatbotTypeId}`, payload.chatbot);
            return response.data;
        }
    });
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/middlewares/chatbot.middleware.ts